





















import { Component, Vue, Watch } from 'vue-property-decorator';
import SidebarItem from '@/components/sidebarItem.vue';
@Component({
  components: {
    SidebarItem,
  },
})
export default class LayoutComponent extends Vue {
  get menuObj() {
    return this.initMenu();
  }
  get userInfo() {
    return this.$store.state.userInfo;
  }
  private created() {
    this.hopRouting();
  }
  private hopRouting() {
    const menus = this.initMenu();
    const paths = this.$route.path.split('/');
    if (paths.length < 3) {
      if (menus && menus[0]) {
        if (menus[0].children && menus[0].children.length > 0) {
          this.$router.push(
            this.$route.path +
              '/' +
              menus[0].path +
              '/' +
              menus[0].children[0].path
          );
        } else {
          this.$router.push(this.$route.path + '/' + menus[0].path);
        }
      }
    }
  }
  @Watch('$route')
  private routechange(to: any, from: any) {
    this.hopRouting();
  }
  // 获取当前目录下的子目录
  private initMenu() {
    const { options } = this.$router as any;
    const children = options.routes[0].children;
    let obj:any = {};
    for (const child of children) {
      if ((child.name).indexOf('task') > -1) {
        // 无meta信息的路由无需展示在菜单中
        const taskList =
          child.children && child.children.filter((items: any) => items.meta);
        obj.taskList = taskList
      }
      if ((child.name).indexOf('mine') > -1) {
        // 无meta信息的路由无需展示在菜单中
        if(this.userInfo && this.userInfo.id){
          let mineList =
                  child.children && child.children.filter((items: any) => items.meta);
          obj.mineList = mineList
          if(this.userInfo && this.userInfo.team_general_user){
            obj.mineList = obj.mineList.filter((item:any) => item.name != 'drawcash' && item.name !== 'income')
          }else if(this.userInfo && this.userInfo.user_is_announcer){
            obj.mineList = obj.mineList.filter((item:any) => item.name != 'drawcash' && item.name !== 'income')
          }
        }else{
          obj.mineList = []
        }
      }
    }
    return obj
  }
}
